import { useEffect } from 'react';
import { useFormik } from 'formik';

import { initialValues, validationSchema } from './formData';
import { ProductDataProps } from './props';

import { Product } from '../../../../../../shared/types/systemConfiguration/products';

export const useProductData = ({
    data,
    onChangeData,
    onChangeFormik,
}: ProductDataProps) => {
    const onSubmit = (data: Product) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('code', data?.code);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('description', data?.description || '');
        formik?.setFieldValue('active', data?.active ?? true);
        formik?.setFieldValue(
            'applyEscalations',
            data?.applyEscalations ?? true
        );
        formik?.setFieldValue('applyPqr', data?.applyPqr ?? true);
    }, [data]);

    return {
        formik,
    };
};
